import { Separator } from '@sr/ui-library';
import type { ReactNode } from 'react';
import {
  type AppPaginationFooterProps,
  AppPaginationSummary,
} from './AppPagination';

type ListToolbarProps = AppPaginationFooterProps & {
  sort?: ReactNode;
};

/**
 * The row between a list page's search/filters and its results: a divider, then
 * sort on the left and pagination on the right. Without a sort the counter
 * moves to the left (UI/UX, APP-2506). Always shown, even on a single page,
 * unlike {@link AppPaginationFooter}, which hides itself there.
 */
export const ListToolbar = ({ sort, ...paginationProps }: ListToolbarProps) => (
  <div className="space-y-4">
    <Separator />

    {sort ? (
      <div className="flex flex-wrap items-center justify-between gap-3">
        {sort}
        <AppPaginationSummary className="gap-4" {...paginationProps} />
      </div>
    ) : (
      <AppPaginationSummary className="justify-between" {...paginationProps} />
    )}
  </div>
);
